import { useState, useEffect } from 'react';

const FloatingCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroEnd = document.getElementById('hero-end');
      const composer = document.getElementById('post');

      const pastHero = heroEnd ? heroEnd.getBoundingClientRect().top < 0 : window.scrollY > window.innerHeight;
      const composerVisible = composer
        ? composer.getBoundingClientRect().top < window.innerHeight && composer.getBoundingClientRect().bottom > 0
        : false;

      setVisible(pastHero && !composerVisible);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => document.getElementById('post')?.scrollIntoView({ behavior: 'smooth' })}
      className="fixed bottom-6 right-6 z-40 px-6 py-3 rounded-full bg-primary text-primary-foreground font-bebas text-lg tracking-wide shadow-lg hover:bg-primary/90 transition-all"
      style={{ animation: 'fadeInUp 0.3s ease-out' }}
    >
      Post an Idea →
    </button>
  );
};

export default FloatingCTA;
